<template>
  <view>
    <cube-button bindclick="showPickerWithUpdate">Use updateData</cube-button>
    <cube-picker-modal
      wx:ref="picker"
      title="更新数据"
      list="{{ dataList }}"
      selected-index="{{ selectedIndex }}"
    />
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
createComponent({
  data: {
    selectedIndex: [0],
    dataList: [[ { text: '剧毒', value: '剧毒' }, { text: '蚂蚁', value: '蚂蚁' }, { text: '幽鬼', value: '幽鬼' } ]],
  },
  methods: {
    showPickerWithUpdate() {
      this.$refs.picker.show()
      this.dataList = [[ { text: '剧毒', value: '剧毒' }, { text: '蚂蚁', value: '蚂蚁' }, { text: '幽鬼', value: '幽鬼' } ]]
      this.selectedIndex = [0]
      setTimeout(() => {
        this.$refs.picker.updateData(
          [[ { text: '输出', value: '输出' }, { text: '控制', value: '控制' }, { text: '核心', value: '核心' } ]],
          [2]
        )
      }, 3000)
    }
  }
})
</script>

<style lang="stylus">
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-picker-modal": "@mpxjs/mpx-cube-ui/src/components/picker-modal/index"
    }
  }
</script>
